import { render, staticRenderFns } from "./NTuseLandTotalChart.vue?vue&type=template&id=33a0e0f4&scoped=true"
import script from "./NTuseLandTotalChart.vue?vue&type=script&lang=js"
export * from "./NTuseLandTotalChart.vue?vue&type=script&lang=js"
import style0 from "./NTuseLandTotalChart.vue?vue&type=style&index=0&id=33a0e0f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a0e0f4",
  null
  
)

export default component.exports